<template>
  <div>
    <div>
      <b-card no-body class="overflow-hidden mb-4" v-for="place in places" :key="place.id">
        <router-link :to="{ name: 'Place' , params: { placeId: place.id}}">
          <b-row>
            <b-col sm="4" lg="6">
              <b-card-img v-bind:src="place.imgUrl" class="rounded-0"></b-card-img>
            </b-col>
            <b-col sm="8" lg="6">
              <b-card-body v-bind:title="place.name">
                <b-card-text>{{place.description}}</b-card-text>
              </b-card-body>
            </b-col>
          </b-row>
        </router-link>
      </b-card>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/firebase'
export default {
  name: 'Home',
  data () {
    return {
      places: []
    }
  },
  //ここから追加
  firestore () {
    return {
      places: db.collection('places')
    }
  }
  //ここまで追加
}
</script>

<style scoped>
  .card {
    margin-bottom: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Home.vue